import Grid from "@mui/material/Grid";
import {Box, Typography} from "@mui/material";
import Stack from "@mui/material/Stack";
import Image from "next/image";
import React from "react";
import {useTheme} from "@mui/material/styles";
import {SoftwareSectionProps} from "@/types/software";

export default function SoftwareSection({
                                            children,
                                            image,
                                            isHero,
                                            isReverse,
                                            description,
                                            title
                                        }: SoftwareSectionProps) {
    const theme = useTheme();

    return (
        <Grid
            container
            spacing = {3}
            sx = {{
                mb: {md: 4, xs: 0},
                flexDirection: {xs: "column", md: isReverse ? "row" : "row"},
            }}
        >
            <Grid
                item
                xs = {12}
                md = {6}
                display="flex"
                flexDirection="column"
                alignItems={{xs: "center", md: "start"}}
                textAlign={{xs: "center", md: "start"}}
                justifyContent="center"
                order={{xs: 1, md: isReverse ? 2 : 1}}
            >
                <Typography my = {2} variant = {isHero ? "h1" : "h2"} >
                    {title}
                </Typography >

                <Typography color = {theme.palette.grey[600]} mb = {2} fontSize = {16} >
                    {description}
                </Typography >

                <Stack mt={2} spacing = {2} direction = "row" >
                    {children}
                </Stack >

            </Grid >

            <Grid
                item
                xs = {12}
                md = {6}
                display="flex"
                justifyContent={isReverse ? "start" : "end"}
                order={{xs: 2, md: isReverse ? 1 : 2}}
            >
                <Box
                    height={{xs: 250, md: 360}}
                    position="relative"
                    sx = {{
                        aspectRatio: 1,
                    }}
                >
                    <Image src = {image} alt = {title} fill style = {{objectFit: "contain"}} />
                </Box >
            </Grid >
        </Grid >
    );
}
